import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 512 512" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path d="M441.412 140.235v338.781c0 18.219-14.778 32.983-32.983 32.983H103.572c-18.219 0-32.983-14.764-32.983-32.983V32.983C70.588 14.764 85.352 0 103.572 0h197.605l140.235 140.235z" fill="#fbbb00"/>
        <path fill="#e2a203" d="M320.31 137.188l121.102 49.891v-46.844l-68.661-20.273z"/>
        <path d="M441.412 140.235H334.16c-18.22 0-32.983-14.764-32.983-32.983V0l140.235 140.235z" fill="#f4d37d"/>
        <g fill="none" stroke="#fff" strokeWidth="15" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10">
            <path d="M323.239 233.469H188.752c-12.466 0-22.571 10.106-22.571 22.571v134.487c0 12.466 10.106 22.571 22.571 22.571h134.487c12.466 0 22.571-10.106 22.571-22.571V256.041c.001-12.466-10.105-22.572-22.571-22.572z"/>
            <path d="M199.895 282.451h112.201v81.658H199.895z"/>
        </g>
    </svg>
)

export default class IconGooglePresentation extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
